import { Document, Page, View } from '@react-pdf/renderer';
import { StyleSheet } from '@react-pdf/renderer';
import { Header } from './Header';
import { Table } from './Table';
import { HolidayDto } from '../../commonTypes/organization.types';

const styles = StyleSheet.create({
    page: {
        padding: 30,
        flexDirection: 'column',
    },
    header: {
        fontSize: 12,
        marginBottom: 20,
        textAlign: 'center',
        color: 'black',
    },
});

interface ILeaveRequestProps {
    filteredRequests: any[];
    totalDays: number;
    holidays: HolidayDto[];
    period: string;
    userInfo?: string;
}
export const LeaveRequestPDF = ({ filteredRequests, totalDays, holidays, period, userInfo }: ILeaveRequestProps) => {
    return (
        <Document>
            <Page size="A4" style={styles.page}>
                <View>
                    <Header userInfo={userInfo} period={period || undefined} />
                    <Table filteredRequests={filteredRequests} totalDays={totalDays} holidays={holidays} userInfo={userInfo} />
                </View>
            </Page>
        </Document>
    );
};
